import { render } from "./PlantillaRegistro.vue?vue&type=template&id=07fe5d2c&scoped=true"
import script from "./PlantillaRegistro.vue?vue&type=script&lang=js"
export * from "./PlantillaRegistro.vue?vue&type=script&lang=js"

import "./PlantillaRegistro.vue?vue&type=style&index=0&id=07fe5d2c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fe5d2c"]])

export default __exports__